// extracted by mini-css-extract-plugin
export default {"wrap":"NotFound_wrap__n96NJ","title":"NotFound_title__f917b","text":"NotFound_text__duXat","notFound":"NotFound_notFound__+iVNo"};